import React, { useState } from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import ManageImprestLinesDialog from "./ManageImprestLinesDialog";
import ImprestDocumentsDrawer from "./ImprestDocumentsDrawer";
import Swal from "sweetalert2";
import { uploadDocuments } from "../../../data/DocumentManager/documentManagerClient";

const uploadSupportingDocuments = async ({
  imprestId,
  employeeId,
  files,
}) => {
  return uploadDocuments(
    "/upload/imprest",
    {
      imprest_id: imprestId,
      employee_id: employeeId,
    },
    files
  );
};

const ManageImprestLinesWithDocuments = ({ open, onClose, imprestData, refetchData }) => {
  const [openDocs, setOpenDocs] = useState(false);
  const [uploading, setUploading] = useState(false);

  const rawDecoded = localStorage.getItem("decodedToken");
  const decodedToken = rawDecoded ? JSON.parse(rawDecoded) : {};

  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    // Validate file sizes (5MB = 5 * 1024 * 1024 bytes)
    const maxSize = 5 * 1024 * 1024;
    const oversizedFiles = files.filter(file => file.size > maxSize);

    if (oversizedFiles.length > 0) {
      Swal.fire({
        icon: "error",
        title: "File Too Large",
        text: `One or more files exceed the 5MB size limit. Please choose smaller files.`,
      });
      event.target.value = ""; // Reset input
      return; // Abort upload
    }

    try {
      setUploading(true);
      await uploadSupportingDocuments({
        imprestId: imprestData.id,
        employeeId: imprestData.employeeId || decodedToken.EmployeeId,
        files,
      });

      Swal.fire("Success", "Documents uploaded successfully", "success");
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire("Error", error.message, "error");
    } finally {
      setUploading(false);
      // Reset input value to allow uploading the same file again if needed
      event.target.value = "";
    }
  };

  return (
    <>
      <ManageImprestLinesDialog
        open={open}
        onClose={onClose}
        imprestData={imprestData}
        refetchData={refetchData}
        extraActions={
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              component="label"
              disabled={uploading}
              sx={{ fontWeight: "bold" }}
            >
              {uploading ? <CircularProgress size={20} color="inherit" /> : "Upload Document"}
              <input
                type="file"
                multiple
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                style={{
                  clip: 'rect(0 0 0 0)',
                  clipPath: 'inset(50%)',
                  height: 1,
                  overflow: 'hidden',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  whiteSpace: 'nowrap',
                  width: 1,
                }}
                onChange={handleFileUpload}
              />
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => setOpenDocs(true)}
              sx={{ fontWeight: "bold" }}
            >
              View Documents
            </Button>
          </Box>
        }
      />

      {/* Drawer */}
      <ImprestDocumentsDrawer
        open={openDocs}
        onClose={() => setOpenDocs(false)}
        imprestId={imprestData?.id}
      />
    </>
  );
};

export default ManageImprestLinesWithDocuments;
